// Nine Lives '84 - simulation constants.
//
// World units are the original's CGA pixels: 320 wide, 200 tall, Y up with
// the street at y = 0. The simulation ticks at 60 Hz (the original ran on the
// 18.2 Hz BIOS tick); speeds are in units per second so the numbers can be
// tuned against the DOS version directly.

export const FPS = 60;
export const DT = 1 / FPS;

export const WORLD_W = 320;
export const WORLD_H = 200;

/** Command word bits consumed by the simulation each tick. */
export const K_LEFT = 1;
export const K_RIGHT = 2;
export const K_JUMP = 4;
export const K_DOWN = 8;
export const K_ACTION = 16;
export const K_SOUND = 32;
/** Up held (not edge-triggered like K_JUMP); used for swimming. */
export const K_UP = 64;
/** Pause toggle (edge-triggered); handled outside the simulation. */
export const K_PAUSE = 128;

// Cat body and movement.
export const CAT_W = 14;
export const CAT_H = 10;
/** Ground acceleration and top running speed, units/s. */
export const RUN_ACCEL = 700;
export const RUN_MAX = 105;
/** Deceleration on the ground with no direction held. */
export const FRICTION = 900;
/** Acceleration while airborne: a nudge of steering, so a hop stays a hop. */
export const AIR_ACCEL = 30;
export const GRAVITY = 520;
export const MAX_FALL = 300;
/** Vertical launch speed; discrete apex height is just under 39 units. */
export const JUMP_VY = 205;
/** Below this ground speed a jump is a standing hop, not a running jump. */
export const RUN_JUMP_SPEED = 70;
/** Horizontal speed given to a standing hop when a direction is held. */
export const HOP_VX = 34;
/** Grace ticks after walking off an edge during which a jump still counts. */
export const COYOTE_TICKS = 5;
/** Ticks a jump press is remembered while airborne so it fires on landing. */
export const JUMP_BUFFER_TICKS = 6;
/** Ticks one-way platforms are ignored after dropping through one. */
export const DROP_TICKS = 8;

// Alley inhabitants.
export const DOG_W = 24;
export const DOG_H = 12;
export const MOUSE_W = 7;
export const MOUSE_H = 4;
export const JUNK_W = 7;
export const JUNK_H = 7;
export const WINDOW_W = 26;
export const WINDOW_H = 24;
/** Ticks the dog-fight lasts before a life is lost. */
export const CAUGHT_TICKS = 75;
/** Ticks of invulnerability after respawning. */
export const INVULN_TICKS = 150;
// Rooms.
export const BROOM_W = 8;
export const BROOM_H = 30;
/** Top of the sill inside a room's exit window. */
export const EXIT_SILL_TOP = 60;
/** Most pawprints on the floor at once; the oldest fades. */
export const MAX_PRINTS = 8;
/** Ticks between pawprints while running on the floor. */
export const PRINT_EVERY = 10;
/** Ticks the broom spends over a print before it is gone: a second and a half. */
export const SWEEP_TICKS = 90;
/** The broom dawdles between prints, at this fraction of its chasing speed. */
export const SWEEP_SPEED = 0.65;
/** Ticks Tabs is out of sight crawling through the cheese. */
export const CRAWL_TICKS = 45;
export const SPIDER_W = 14;
export const SPIDER_H = 10;
// Birdcage room.
export const CAGE_W = 24;
export const CAGE_H = 28;
export const BIRD_W = 10;
export const BIRD_H = 8;
/** How far a nudge slides the cage. */
export const NUDGE_SLIDE = 12;
// Sleeping dogs room.
export const BOWL_W = 18;
export const BOWL_H = 6;
/** How close (centre to centre, on the floor) a dog can sense Tabs. */
export const DOG_SENSE = 42;
/** Meter level at which a dog growls a warning. */
export const GROWL_AT = 0.5;
// Fishbowl room.
export const FISH_W = 9;
export const FISH_H = 5;
export const EEL_W = 24;
export const EEL_H = 6;
/** Top of the water in the tank; above it is air. */
export const WATER_SURFACE = 170;
export const SWIM_ACCEL = 260;
export const SWIM_MAX = 90;
/** Per-tick velocity retained: the water's drag. */
export const SWIM_DRAG = 0.96;
/** Slow sink when not kicking. */
export const SWIM_SINK = 12;
/** Ticks Tabs is stunned by an eel. */
export const SHOCK_TICKS = 45;
/** Air regained per tick at the surface. */
export const AIR_REFILL = 10;
// Clementine's room.
export const HEART_W = 30;
export const HEART_H = 6;
/** Tops of the six rows of hearts. */
export const ROW_TOPS = [28, 54, 80, 106, 132, 158];
export const ARROW_W = 9;
export const ARROW_H = 3;
/** Ticks an arrow flies before it fades. */
export const ARROW_LIFE = 420;
export const GIFT_W = 8;
export const GIFT_H = 8;
export const MAX_GIFTS = 3;
/** Ticks a brother waits after knocking Tabs before it can again. */
export const BROTHER_COOLDOWN = 40;
/** Ticks the simulation holds still while the view goes through a window. */
export const FREEZE_TICKS = 30;
/** A shorter hold for the dive into the tank and the climb out. */
export const FREEZE_SHORT = 16;
/** Room bonus: base, drop per second, floor. Multiplied by the level. */
export const BONUS_BASE = 1000;
export const BONUS_PER_SECOND = 15;
export const BONUS_MIN = 200;
